<template>
    <div :class="`address address-align-${localAlign}`">
        <label for="address" class="field-label" @click="focusFieldLabel" v-if="!editingFieldLabel">
            {{ displayFieldAddress }}
            <span v-if="isRequired" class="required-indicator">*</span>
        </label>
                    <input
            v-if="editingFieldLabel"
                        type="text"
            class="field-label-input"
            placeholder="Adres"
            v-model="localFieldAddress"
            @blur="stopEditingFieldLabel"
            @keydown.enter="stopEditingFieldLabel"
            ref="fieldLabelInput"
        />
        <div class="inputs-container">
            <!-- Address Line 1 -->
            <div :class="['input-wrapper', { 'filled': addressLine1Value }]">
                    <input
                        type="text"
                    id="address1"
                    name="address1"
                    v-model="addressLine1Value"
                    @input="updateField"
                    @focus="onFocus"
                    @blur="onBlur"
                    :class="{ 'has-value': addressLine1Value }"
                />
                <label for="address1" class="floating-label">{{ localAddressLine1 || 'Adres Satırı 1' }}</label>
                <div class="input-border"></div>
                </div>

            <!-- Address Line 2 -->
            <div :class="['input-wrapper', { 'filled': addressLine2Value }]">
                        <input
                            type="text"
                    id="address2"
                    name="address2"
                    v-model="addressLine2Value"
                    @input="updateField"
                    @focus="onFocus"
                    @blur="onBlur"
                    :class="{ 'has-value': addressLine2Value }"
                />
                <label for="address2" class="floating-label">{{ localAddressLine2 || 'Adres Satırı 2' }}</label>
                <div class="input-border"></div>
                    </div>

            <!-- City and State Row -->
            <div class="input-wrapper-two">
                <div :class="['input-wrapper-half', { 'filled': cityValue }]">
                        <input
                            type="text"
                        id="city"
                        name="city"
                        v-model="cityValue"
                        @input="updateField"
                        @focus="onFocus"
                        @blur="onBlur"
                        :class="{ 'has-value': cityValue }"
                    />
                    <label for="city" class="floating-label">{{ localDistrict || 'İlçe' }}</label>
                    <div class="input-border"></div>
                </div>
                <div :class="['input-wrapper-half', { 'filled': stateValue }]">
                    <input
                        type="text"
                        id="state"
                        name="state"
                        v-model="stateValue"
                        @input="updateField"
                        @focus="onFocus"
                        @blur="onBlur"
                        :class="{ 'has-value': stateValue }"
                    />
                    <label for="state" class="floating-label">{{ localState || 'Şehir' }}</label>
                    <div class="input-border"></div>
                </div>
            </div>

            <!-- Postal Code -->
            <div :class="['input-wrapper', { 'filled': postalCodeValue }]">
                <input
                    type="text"
                    id="postalcode"
                    name="postalcode"
                    v-model="postalCodeValue"
                    @input="updateField"
                    @focus="onFocus"
                    @blur="onBlur"
                    :class="{ 'has-value': postalCodeValue }"
                />
                <label for="postalcode" class="floating-label">{{ localPostalCode || 'Posta Kodu' }}</label>
                <div class="input-border"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "FormAdress",
    props: {
        fieldAddress: String,
        align: String,
        addressLine1: String,
        addressLine2: String,
        district: String,
        postalCode: String,
        state: String,
        item: Object,
        isRequired: Boolean,
    },
    data() {
        return {
            localFieldAddress: this.fieldAddress || "",
            localAlign: this.align || "top",
            localAddressLine1: this.addressLine1 || "",
            localAddressLine2: this.addressLine2 || "",
            localDistrict: this.district || "",
            localPostalCode: this.postalCode || "",
            localState: this.state || "",
            addressLine1Value: "",
            addressLine2Value: "",
            cityValue: "",
            stateValue: "",
            postalCodeValue: "",
            editingFieldLabel: false,
            updateTimer: null,
        };
    },
    computed: {
        displayFieldAddress() {
            return this.localFieldAddress || "Adres";
        },
    },
    methods: {
        ...mapActions("forms", ["updateFormField"]),
        focusFieldLabel() {
            this.editingFieldLabel = true;
            this.$nextTick(() => {
                if (this.$refs.fieldLabelInput) {
                    this.$refs.fieldLabelInput.focus();
                }
            });
        },
        stopEditingFieldLabel() {
            this.editingFieldLabel = false;
            this.updateField();
        },
        onFocus(event) {
            event.target.parentElement.classList.add('focused');
        },
        onBlur(event) {
            event.target.parentElement.classList.remove('focused');
        },
        updateField() {
            let self = this;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            this.updateTimer = setTimeout(function () {
            const updateFields = {
                address: {
                        fieldAddress: self.localFieldAddress,
                        align: self.localAlign,
                        addressLine1: self.localAddressLine1,
                        addressLine2: self.localAddressLine2,
                        district: self.localDistrict,
                        postalCode: self.localPostalCode,
                        state: self.localState,
                        isRequired: self.isRequired,
                    },
                };
                self.updateFormField({
                    siteId: self.item.siteId,
                    formFieldId: self.item._id,
                updateFields: updateFields,
            });
                self.$emit("update-field", updateFields);
            }, 200);
        },
    },
    watch: {
        fieldAddress(newVal) {
            this.localFieldAddress = newVal;
        },
        align(newVal) {
            this.localAlign = newVal;
        },
        addressLine1(newVal) {
            this.localAddressLine1 = newVal;
        },
        addressLine2(newVal) {
            this.localAddressLine2 = newVal;
        },
        district(newVal) {
            this.localDistrict = newVal;
        },
        postalCode(newVal) {
            this.localPostalCode = newVal;
        },
        state(newVal) {
            this.localState = newVal;
        },
    },
};
</script>

<style lang="scss" scoped>
/* Base Address Styles */
.address {
    width: 100%;
    max-width: 700px;
    margin: clamp(0.5rem, 1.5vw, 1rem) auto;
    padding: clamp(0.625rem, 1.5vw, 0.875rem);
    position: relative;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

    background: linear-gradient(145deg,
        rgba(255, 255, 255, 0.02) 0%,
        rgba(255, 255, 255, 0.01) 100%);
    border-radius: 0.75rem;
    border: 1px solid rgba(255, 255, 255, 0.06);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
        background: linear-gradient(145deg,
            rgba(255, 255, 255, 0.03) 0%,
            rgba(255, 255, 255, 0.02) 100%);
    }

    .field-label {
        display: block;
        font-size: clamp(0.95rem, 2.2vw, 1.1rem);
        font-weight: 600;
        margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
        color: var(--text-primary, rgba(55, 65, 81, 0.9));
        line-height: 1.4;
        letter-spacing: -0.01em;
        cursor: pointer;

        .required-indicator {
            color: #ef4444;
            margin-left: 0.125rem;
            font-weight: 700;
        }
    }

    .field-label-input {
        font-size: clamp(0.95rem, 2.2vw, 1.1rem);
        font-weight: 600;
        margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
        color: var(--text-primary, rgba(55, 65, 81, 0.9));
        line-height: 1.4;
        letter-spacing: -0.01em;
        border: none;
        background: transparent;
        outline: none;
        border-bottom: 2px solid #f26a52;
        padding: 0 0 2px 0;

        &::placeholder {
            color: rgba(156, 163, 175, 0.7);
        }
    }

    .inputs-container {
        display: flex;
        flex-direction: column;
        gap: clamp(0.5rem, 1.5vw, 0.75rem);
    }

    .input-wrapper,
    .input-wrapper-half {
        position: relative;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        min-width: 0;

        input {
            width: 100%;
            padding: clamp(0.6rem, 1.5vw, 0.75rem) clamp(0.6rem, 1.2vw, 0.75rem);
            font-size: clamp(0.875rem, 1.8vw, 0.9rem);
            line-height: 1.4;
            color: var(--text-primary, rgba(55, 65, 81, 0.9));
            background: rgba(255, 255, 255, 0.8);
            border: 1px solid rgba(209, 213, 219, 0.6);
            border-radius: 0.375rem;
            box-sizing: border-box;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            font-family: inherit;
            backdrop-filter: blur(10px);

            &::placeholder {
                color: transparent;
            }

            &:focus {
                outline: none;
                border-color: #f26a52;
                background: rgba(255, 255, 255, 0.95);
                box-shadow:
                    0 0 0 3px rgba(242, 106, 82, 0.1),
                    0 4px 12px rgba(0, 0, 0, 0.05);
                transform: translateY(-1px);
            }

            &:hover:not(:focus) {
                border-color: rgba(107, 114, 128, 0.4);
                background: rgba(255, 255, 255, 0.85);
            }
        }

        .floating-label {
            position: absolute;
            left: clamp(0.6rem, 1.2vw, 0.75rem);
            top: 50%;
            transform: translateY(-50%);
            font-size: clamp(0.875rem, 1.8vw, 0.9rem);
            color: rgba(107, 114, 128, 0.7);
            pointer-events: none;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            background: transparent;
            padding: 0 0.25rem;
            font-weight: 500;
        }

        .input-border {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 2px;
            background: linear-gradient(90deg, #f26a52, #e55a42);
            border-radius: 1px;
            transform: scaleX(0);
            transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        &.focused .floating-label,
        &.filled .floating-label,
        input:focus ~ .floating-label,
        input.has-value ~ .floating-label {
            top: 0;
            transform: translateY(-50%);
            font-size: clamp(0.7rem, 1.6vw, 0.8rem);
            color: #f26a52;
            font-weight: 600;
            background: rgba(255, 255, 255, 0.9);
        }

        &.focused .input-border,
        input:focus ~ .input-border {
            transform: scaleX(1);
        }
    }

    .input-wrapper-two {
        display: flex;
        gap: clamp(0.5rem, 1.5vw, 0.75rem);

        @media (max-width: 768px) {
            flex-direction: column;
            gap: clamp(0.5rem, 1.2vw, 0.625rem);
        }

        .input-wrapper-half {
            flex: 1;
        }
    }
}

/* Left Alignment - Label solda, input'lar sağda */
.address-align-left {
    display: flex;
    align-items: flex-start;
    gap: clamp(0.75rem, 2vw, 1rem);
    text-align: left;

    .field-label {
        min-width: clamp(100px, 20vw, 140px);
        flex-shrink: 0;
        margin-bottom: 0;
        padding-top: clamp(0.6rem, 1.5vw, 0.75rem);
        text-align: left;
    }

    .field-label-input {
        min-width: clamp(100px, 20vw, 140px);
        flex-shrink: 0;
        margin-bottom: 0;
        padding-top: clamp(0.6rem, 1.5vw, 0.75rem);
        text-align: left;
    }

    .inputs-container {
        flex: 1;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 0;

        .field-label, .field-label-input {
            min-width: auto;
            padding-top: 0;
            margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
        }

        .inputs-container {
            width: 100%;
        }
    }
        }

/* Right Alignment - Label solda sağa yaslanmış, input'lar sağda */
.address-align-right {
            display: flex;
    align-items: flex-start;
    gap: clamp(0.75rem, 2vw, 1rem);

    .field-label {
        min-width: clamp(100px, 20vw, 140px);
        flex-shrink: 0;
        margin-bottom: 0;
        padding-top: clamp(0.6rem, 1.5vw, 0.75rem);
        text-align: right;
    }

    .field-label-input {
        min-width: clamp(100px, 20vw, 140px);
        flex-shrink: 0;
        margin-bottom: 0;
        padding-top: clamp(0.6rem, 1.5vw, 0.75rem);
        text-align: right;
    }

    .inputs-container {
        flex: 1;
    }

    @media (max-width: 768px) {
            flex-direction: column;
        gap: 0;

        .field-label, .field-label-input {
            min-width: auto;
            padding-top: 0;
            margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
            text-align: left;
        }

        .inputs-container {
                width: 100%;
        }
    }
}

/* Center/Top Alignment (Default) */
.address-align-top {
    text-align: left;
    flex-direction: column;
}

// Mobil optimizasyonları
@media (max-width: 768px) {
    .address {
        margin: clamp(0.25rem, 1vw, 0.5rem) auto;
        padding: clamp(0.5rem, 1.2vw, 0.75rem);

        .field-label {
            font-size: clamp(0.9rem, 2vw, 1rem);
            margin-bottom: clamp(0.375rem, 1vw, 0.5rem);
        }

        .inputs-container {
            gap: clamp(0.5rem, 1.2vw, 0.625rem);
        }

        .input-wrapper,
        .input-wrapper-half {
            input {
                padding: clamp(0.75rem, 2vw, 0.875rem) clamp(0.625rem, 1.5vw, 0.75rem);
                font-size: clamp(0.875rem, 2vw, 0.9rem);
                border-radius: 0.5rem;
            }

            .floating-label {
                left: clamp(0.625rem, 1.5vw, 0.75rem);
                font-size: clamp(0.875rem, 2vw, 0.9rem);

                &.focused,
                &.filled {
                    font-size: clamp(0.75rem, 1.8vw, 0.8rem);
                }
            }
        }
    }
}

@media (max-width: 480px) {
    .address {
        margin: 0.25rem auto;
        padding: 0.5rem;

        .inputs-container {
            gap: 0.5rem;
        }

        .input-wrapper,
        .input-wrapper-half {
            input {
                padding: 0.75rem 0.625rem;
                font-size: 0.875rem;
            }

            .floating-label {
                left: 0.625rem;
                font-size: 0.875rem;

                &.focused,
                &.filled {
                    font-size: 0.75rem;
                }
            }
        }

        .input-wrapper-two {
            gap: 0.5rem;
        }
    }
}

/* Reduced Motion Support */
@media (prefers-reduced-motion: reduce) {
    .address,
    .input-wrapper,
    .input-wrapper-half,
    .input-wrapper input,
    .input-wrapper-half input,
    .floating-label,
    .input-border {
        transition: none;
    }

    .input-wrapper input:focus,
    .input-wrapper-half input:focus {
        transform: none;
    }
}

/* High Performance Mode */
.input-wrapper,
.input-wrapper-half {
    will-change: transform;

    input {
        will-change: transform, box-shadow;
    }

    .floating-label {
        will-change: transform, color, font-size;
    }

    .input-border {
        will-change: transform;
    }
}
</style>
